import React from 'react';
import { useParams } from 'react-router-dom';
// Models
import { IPage } from '@root/models/Page';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { createAuditRecord } from 'app/store/Audit/Audit.async';
// Selectors
import { selectIsLoading, selectStatus } from 'app/store/page/page.selectors';
// MaterialUi
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControlLabel from '@mui/material/FormControlLabel';
// Components
import { AuditOperations } from 'app/store/Audit/Audit.types';
// Utilities
import { selectMyUser } from 'app/store/Users/Users.selectors';
// i18next
import { useTranslation } from 'react-i18next';
import PageActions from 'app/store/page/page.actions';

type Props = {
  open: boolean;
  onClose: () => void;
  onCallback?: () => void;
  pages: any[];
};

const ExportWorkspacePagesToPDFDialog:React.FC<Props> = ({
  // Props
  open, onClose, onCallback, pages
}) => {
  const { t } = useTranslation();

  const { caseId } = useParams<{ caseId:string }>();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const myUser:any = useAppSelector(selectMyUser);
  const status:any = useAppSelector(selectStatus);
  const isLoading:boolean = useAppSelector(selectIsLoading);
  // const allPages = useAppSelector(selectAllPages);
  // const pagesWithPreEvent:Array<IPage> | null = useAppSelector((state:RootState) => selectPagesInWorkspaceByPreEvent(state, { preEvent: true }));
  // const pagesWithoutPreEvent:Array<IPage> | null = useAppSelector((state:RootState) => selectPagesInWorkspaceByPreEvent(state, { preEvent: false }));

  const [ checked, setChecked ] = React.useState<boolean>(false);

  React.useEffect(() => {
    if ( status === 'Success' ){
      onClose();
      if ( onCallback ) onCallback();
      if ( myUser ){
        dispatch(createAuditRecord({
          operation: AuditOperations.ExportWorkspacePagesToPDF,
          data: {
            caseId: Number(caseId),
            userName: myUser.name 
          }
        }));
      }
    }
    // eslint-disable-next-line
  }, [status]);

  const handleExport = () => {
    // let allPages:Array<IPage> = [];
    // let pagesToExport:Array<IPage> = [];
    // if ( pagesWithPreEvent ) allPages = [...allPages, ...pagesWithPreEvent];
    // if ( pagesWithoutPreEvent ) allPages = [...allPages, ...pagesWithoutPreEvent];

    // pages.forEach((page:IPage) => {
    //   const stapleId = page.staple && page.staple.order === 1 ? page.staple.id : null;
    //   if ( stapleId ){
    //     if ( allPages ){
    //       const staplePages = allPages
    //         .filter((p:IPage) => p.staple && p.staple.id === stapleId)
    //         .sort(sortByStapleOrder);
    //       pagesToExport = [...pagesToExport, ...staplePages];
    //     }
    //   } else {
    //     pagesToExport = [...pagesToExport, page];
    //   }
    // });

    // if ( !pagesToExport.length ) return;

    dispatch(PageActions.exportPagesToPDF(pages.map((page:IPage) => ({ documentId: page.documentId, pageNum: page.pageNum }))));
  }

  const handleClose = (_:any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if ( reason === 'backdropClick' ) return;
    onClose();
  }

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>{t('dialogs.consentToExport.title')}</DialogTitle>
      <DialogContent dividers>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={checked}
              onChange={(event:React.ChangeEvent<HTMLInputElement>) => setChecked(event.target.checked)}
            />
          }
          label={t('dialogs.consentToExport.consentLabel')}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={onClose}
        >{t('buttons.close')}</Button>
        <Button
          loading={isLoading}
          disabled={!checked}
          color="primary"
          variant="contained"
          onClick={handleExport}
        >{t('buttons.export')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportWorkspacePagesToPDFDialog;
